<template>
    <li @click="trackClickEvent">
        <div class="hotview_wrap" :data-tiara-cont-id="article.itemId" :data-tiara-imp-id="tiaraImpId" :data-tiara-imp-ordnum="orderNum" :data-tiara-feedback="article.teslaFeedback ? JSON.stringify(article.teslaFeedback) : null">
            <a class="thumb_hotview" :class="CAT" :href="linkUrl">
                <img :src="thumbnailUrl" :alt="altMessage" class="img_thumb"/>
                <span class="wrap_txt" v-if="!hasImage">
                    <span class="inner_txt">
                        <span class="txt_thumb">
                            <span class="txt_cont">{{ article.content }}</span>
                        </span>
                    </span>
                </span>
            </a>
            <span class="detail_hotview">
                <a class="desc_hotview" :class="CAT" :href="linkUrl">{{ title }}</a>
                <a class="cmt_empty" :class="CAT" :href="linkUrl">댓글 <span class="num_placeholder">{{ article.commentCount }}</span></a>
            </span>
        </div>
    </li>
</template>

<script>
import { getThumbnailUrl } from '@src/utils';
import { addClick } from '../tesla-queue.js';

export default {
    props: {
        config: Object,
        article: Object,
		feedback: {
			type: Object,
			default: () => ({})
		},
		orderNum: Number
    },
    data() {
        return {
            DEFAULT_IMG_URL: '//t1.daumcdn.net/cafe_image/mobile/bg_hotview_240322.png'
        }
    },
    computed: {
        svcParam() {
            return this.config.svcParam;
        },
        hasImage() {
            return !!this.article.image;
        },
        baseUrl() {
            return `/${this.article.grpcode}/${this.article.fldid}/${this.article.dataid}`;
        },
        linkUrl() {
            let url = `${this.baseUrl}?svc=${this.svcParam}`;
            if (this.article.bucket) {
                url += `&bucket=${this.article.bucket}`;
            }
            return url;
        },
        thumbnailUrl() {
            if (this.hasImage) {
                return `${getThumbnailUrl(this.article.image, 450, 280, 'S')}&scode=cafe`;
            }
            return this.DEFAULT_IMG_URL;
        },
        title() {
            return this.article.name.replace(/\\"/g, '"');
        },
        altMessage() {
            if (this.hasImage) {
                return '썸네일 이미지';
            }
            return '';
        },
		tiaraImpId() {
			return this.feedback?.tesla_variation_key || this.article.teslaFeedback?.tesla_variation_key || '';
		},
        CAT() {
            return `?c_id=${encodeURIComponent(this.baseUrl)}&c_source=${this.article.grpcode}&c_ch=${this.svcParam}&c_title=${encodeURIComponent(this.title)}`;
        }
    },
    methods: {
        trackClickEvent() {
            addClick(this.article.itemId);
            const feedback = this.feedback || {};
            const teslaFeedback = this.article.teslaFeedback || {};
            this.$trackEvent({
                layer: { layer1: 'hot_list_weekly', layer2: 'recom_content', layer3: 'content' },
                desc: '지난주 카페 인기글',
                url: this.linkUrl,
                customProps: { ...feedback, ...teslaFeedback, imp_id: this.tiaraImpId },
				eventMeta: {
					id: this.article.itemId
				},
				actionKind: 'ClickContent'
            });
        }
    }
}
</script>
